/** Gera uma imagem PNG legível (1080px de largura) com o texto da mensagem, para envio manual pelo celular. Sem dependências. */
function quebrar(ctx, texto, maxW) {
  const linhas = [];
  for (const par of (texto || "").split("\n")) {
    if (!par.trim()) { linhas.push(""); continue; }
    let atual = "";
    for (const palavra of par.split(" ")) {
      // quebra palavras/URLs maiores que a largura em pedaços
      const pedacos = [];
      let p = palavra;
      while (ctx.measureText(p).width > maxW) { let n = p.length - 1; while (n > 1 && ctx.measureText(p.slice(0, n)).width > maxW) n--; pedacos.push(p.slice(0, n)); p = p.slice(n); }
      pedacos.push(p);
      for (const pal of pedacos) {
        const teste = atual ? `${atual} ${pal}` : pal;
        if (ctx.measureText(teste).width > maxW && atual) { linhas.push(atual); atual = pal; } else atual = teste;
      }
    }
    linhas.push(atual);
  }
  return linhas;
}

export async function gerarImagemMensagem({ titulo, texto, empresa, rodape }) {
  const W = 1080, pad = 64, fonte = 36, lh = 52;
  const c = document.createElement("canvas");
  const ctx = c.getContext("2d");
  ctx.font = `${fonte}px Manrope, Arial, sans-serif`;
  const linhas = quebrar(ctx, texto, W - pad * 2);
  const H = pad + 120 + linhas.length * lh + 170;
  c.width = W; c.height = H;
  ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#0A0A0C"; ctx.fillRect(0, 0, W, 110);
  ctx.fillStyle = "#D4AF37"; ctx.font = "bold 40px Manrope, Arial, sans-serif"; ctx.fillText(empresa || "", pad, 68);
  ctx.fillStyle = "#0A0A0C"; ctx.font = "bold 42px Manrope, Arial, sans-serif"; ctx.fillText(titulo || "Mensagem", pad, 110 + 60);
  ctx.font = `${fonte}px Manrope, Arial, sans-serif`; ctx.fillStyle = "#1e293b";
  linhas.forEach((l, i) => ctx.fillText(l, pad, 110 + 60 + 40 + (i + 1) * lh));
  ctx.fillStyle = "#64748b"; ctx.font = "26px Manrope, Arial, sans-serif";
  ctx.fillText(rodape || "Consulte contratos e recibos no portal da empresa.", pad, H - 40);
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  blob.canvas = c;
  return blob;
}

export function baixarBlob(blob, nome) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = nome; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
